<template>
  <div>
    <div class="autocomplete">
      <input
          type="number"
          class="form-control"
          name="supplierAutoCompleteDetailsObj.supplierNumber"
          v-model.trim="supplierAutoCompleteDetailsObj.supplierNumber"
          id="supplierAutoCompleteDetailsObj.supplierNumber"
          @input="onChange"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
          autocomplete="off"
          v-validate="'required'"
          @blur="validateIfSelectedFromDropDown"
          data-vv-validate-on="input"
          @focus="onFocus"
          data-lpignore="true"
      />
      <div class="icon-container" v-if="apiDataLoading">
        <i class="loader"></i>
      </div>

      <span
          class="text-danger input-error-text"
          v-if="errors.has('supplierAutoCompleteDetailsObj.supplierNumber') && !isDropdownOpen"
      >Supplier ID is required<br></span>

      <ul
          :class="autocompleteAPIResultsHeight"
          v-show="isDropdownOpen"
          class="autocomplete-results"
          ref="scrollContainer"
          v-if="!apiDataLoading"
      >
        <li ref="options"
            v-for="(supplierData, i) in apiResponse"
            :key="i"
            @click="setAPIResult(supplierData)"
            class="autocomplete-result"
            :class="{ 'is-active': i === arrowCounter }"
        >
          {{ supplierData.supplierId }}
        </li>
      </ul>
      <ul
          v-if="apiDataLoading"
          v-show="isDropdownOpen"
          class="autocomplete-results"
          :class="autocompleteAPIResultsHeight"
      >
        <li class="text-muted" v-if="apiDataLoading">
          Loading currently available supplier ids...
        </li>
      </ul>
      <small-spinner v-if="supplierDetailsLoading"></small-spinner>
    </div>
  </div>
</template>

<script>
import api from "@/api"
import SmallSpinner from "../../SmallSpinner";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import {mapMutations} from "vuex";
import CONSTANTS from "@/store/constants";
import debounce from "lodash/debounce";
import FORM_LABELS from "../../../store/FormLabels";

export default {
  name: "SupplierIDInput",
  components: {SmallSpinner},
  mixins: [PaymentFormsMixin],
  props:['formType','supplierID','currentSelection'],
  inject: ["$validator"],
  data(){
    return{
      supplierDetailsLoading: false,
      supplierAutoCompleteDetailsObj: {},
      supplierDetails:null,
      isApiError: false,
      isDropdownOpen: false,
      arrowCounter: -1,
      apiResponse: [],
      apiDataLoading: false,
      ARROW_COUNTER_DEFAULT_INDEX: -1,
      autocompleteResult: []
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.supplierAutoCompleteDetailsObj.supplierNumber = this.currentSelection
    this.supplierAutoCompleteDetailsObj.number = this.currentSelection
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  computed: {
    autocompleteAPIResultsHeight() {
      return this.apiResponse.length >= 4 ? 'autocomplete-results-height-100' : 'autocomplete-results-height-auto'
    },
  },
  created(){
    this.supplierAutoCompleteDetailsObj.supplierNumber = this.currentSelection
    //if a supplier ID gets populated via supplierName auto populate, we need to re-run supplierIDEntered logic
    //It ensures bank information is updated for the supplier ID
    if(this.supplierAutoCompleteDetailsObj.supplierNumber && this.supplierAutoCompleteDetailsObj.supplierNumber.length  === CONSTANTS.SUPPLIER_ID_MAX_LENGTH)
      this.onSupplierIDEntered()
  },
  methods:{
    ...mapMutations(["setBankDetailsDropdownValues"]),
    validateIfSelectedFromDropDown(){
      if(this.supplierAutoCompleteDetailsObj.supplierNumber !== this.supplierAutoCompleteDetailsObj.number){
        this.supplierAutoCompleteDetailsObj.number = this.supplierAutoCompleteDetailsObj.supplierNumber
        this.supplierAutoCompleteDetailsObj.supplierNumber = ''
      }
    },
    clearMessages(){
      this.supplierDetails = null;
    },
    fixScrolling(){
      if( this.$refs.options[this.arrowCounter] &&  this.$refs.options[this.arrowCounter].clientHeight) {
        const liH = this.$refs.options[this.arrowCounter].clientHeight;
        this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.apiResponse.length) {
        this.arrowCounter = this.arrowCounter + 1;
      } else {
        this.arrowCounter = 0
      }
      this.fixScrolling()
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.fixScrolling()
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
        this.arrowCounter = this.ARROW_COUNTER_DEFAULT_INDEX;
      }
    },
    checkForValidation(){
      this.$validator.validateAll()
    },
    setAPIResult(supplierDetailsList) {
      this.supplierAutoCompleteDetailsObj.supplierNumber = supplierDetailsList.supplierId
      this.supplierAutoCompleteDetailsObj.number = this.supplierAutoCompleteDetailsObj.supplierNumber
      this.updateWithCurrentValue(supplierDetailsList)
      this.isDropdownOpen = false
      this.onSupplierIDEntered()
    },
    onFocus() {
      this.currentSelection !== this.supplierAutoCompleteDetailsObj.number ? this.onChange() : null
    },
    onChange() {
      this.searchAndDebounce(this)
      if(this.apiResponse.length === 0){
        this.isDropdownOpen = false;
      }
    },
    searchAndDebounce: debounce(
        that => {
          that.getSupplierIdAutocompleteResults();
        },
        500,
        { leading: true }
    ),
    onEnter(e) {
      e.preventDefault();
      if (this.supplierAutoCompleteDetailsObj.supplierNumber) {
        if(this.arrowCounter > this.ARROW_COUNTER_DEFAULT_INDEX) {
          this.updateWithCurrentValue()
        }
        this.isDropdownOpen = false;
        this.arrowCounter = this.ARROW_COUNTER_DEFAULT_INDEX;
        this.onSupplierIDEntered()
      }
    },
    updateWithCurrentValue(supplierDetailsList) {
      if (supplierDetailsList){
        this.supplierAutoCompleteDetailsObj.supplierNumber = supplierDetailsList.supplierNumber
        this.supplierAutoCompleteDetailsObj.supplierName = supplierDetailsList.supplierName
      }else{
        this.supplierAutoCompleteDetailsObj.supplierNumber = this.apiResponse[this.arrowCounter].supplierNumber
        this.supplierAutoCompleteDetailsObj.supplierName = this.apiResponse[this.arrowCounter].supplierName
      }
      this.updateCompanyCodeAndName(supplierDetailsList)
      this.$emit('onSupplierIDEntered',this.supplierAutoCompleteDetailsObj)
    },
    updateCompanyCodeAndName(supplierDetailsList) {
      let filteredCompanyCodeAndNameList = []
      let filteredAPIResponse = this.autocompleteResult.filter(suppliers => suppliers.supplierNumber === supplierDetailsList.supplierNumber)
      if(filteredAPIResponse && filteredAPIResponse.length > 0) {
        filteredAPIResponse.forEach(response => {
          filteredCompanyCodeAndNameList.push({
            value: response.companyCode,
            text: response.companyCode + ' - ' + response.companyCodeText
          })
        })
      }
      this.$emit("uniqueCompanyCodeList",filteredCompanyCodeAndNameList)
    },
    async onSupplierIDEntered(){
      if(this.supplierAutoCompleteDetailsObj.supplierNumber && this.supplierAutoCompleteDetailsObj.supplierNumber.length<=CONSTANTS.SUPPLIER_ID_MAX_LENGTH && (
          this.$validator.errors.items && this.$validator.errors.items.length>0 &&
          this.$validator.errors.items[0].field && this.$validator.errors.items[0].field!=="supplierID" ||
          (!this.$validator.errors.items || this.$validator.errors.items.length===0) )){
        try {
          this.supplierDetailsLoading = true;
          await this.getSupplierBankInformationById()
        } finally {
          this.supplierDetailsLoading = false;
        }
      }
    },
    async getSupplierIdAutocompleteResults() {
      try {
        let supplierData = {}
        supplierData.supplierId = this.supplierAutoCompleteDetailsObj.supplierNumber
        if (this.supplierAutoCompleteDetailsObj.supplierNumber && this.supplierAutoCompleteDetailsObj.supplierNumber.length > CONSTANTS.MINIMUM_CHAR_LENGTH_FOR_AUTOCOMPLETE && this.supplierAutoCompleteDetailsObj.supplierNumber.length<=CONSTANTS.SUPPLIER_ID_MAX_LENGTH) {
          this.apiDataLoading = true
          const response = await api.getNONPOAutocompleteSupplierResults(this.updateSupplierAutoCompleteData(supplierData))
          if(response && response.data && response.data.data && response.data.data.fetchInvoiceDetail && response.data.data.fetchInvoiceDetail.invoiceResponse && response.data.data.fetchInvoiceDetail.invoiceResponse) {
            let autocompleteResult = response.data.data.fetchInvoiceDetail.invoiceResponse.invoiceDetails
            if (autocompleteResult && autocompleteResult.length > 0) {
              autocompleteResult.forEach(result => {
                result.supplierId =  result.supplierNumber
              })
              this.autocompleteResult = autocompleteResult
              this.apiResponse = this.getUniqueSupplierIdAndCompanyCodeList(autocompleteResult)
              this.isDropdownOpen = true
            }else{
              this.apiResponse = []
              this.isDropdownOpen = false
              this.$emit('noAutoCompleteResults',FORM_LABELS.SUPPLIER_ID)
            }
          }
        }else{
          this.apiResponse = []
          this.isDropdownOpen = false
          if(this.supplierAutoCompleteDetailsObj.supplierNumber && this.supplierAutoCompleteDetailsObj.supplierNumber.length > CONSTANTS.SUPPLIER_ID_MAX_LENGTH){
            this.$emit('supplierIdMaxLengthExceeded')
          }
        }
      } catch(e) {
        this.isApiError = true
      }finally {
        this.apiDataLoading = false
      }
    },
    getUniqueSupplierIdAndCompanyCodeList(supplierIdList) {
      let uniqueSuppliersList = []
      let autocompleteCompanyCodeList = []
      let uniqueCompanyCodeList = []
      supplierIdList.forEach((supplier) => {
        let isSupplierExist = uniqueSuppliersList.find(item => item.supplierId.trim() === supplier.supplierId.trim())
        if (!isSupplierExist){
          uniqueSuppliersList.push(supplier)
        }
      })
      supplierIdList.map((company) => {
        autocompleteCompanyCodeList.push({value: company.companyCode, text: company.companyCode + ' - ' + company.companyCodeText})
      })
      uniqueCompanyCodeList = [...new Map(autocompleteCompanyCodeList.map((item) => [item["value"], item])).values()];
      this.$emit("uniqueCompanyCodeList",uniqueCompanyCodeList)
      return uniqueSuppliersList
    },
    async getSupplierBankInformationById() {
      try {
        let res = await api.getPOSupplierDetailsById(this.supplierAutoCompleteDetailsObj.supplierNumber,this.formType)
        this.isApiError = false
        if(res.data && res.data.data.fetchWebformDetail && res.data.data.fetchWebformDetail.webformResponse){
          this.supplierDetails = res.data.data.fetchWebformDetail.webformResponse.invoiceDetail;
        }
        if (res.data && res.data.data.fetchWebformDetail && res.data.data.fetchWebformDetail.webformResponse && res.data.data.fetchWebformDetail.webformResponse.bankDetails){
          this.setBankDetailsDropdownValues(res.data.data.fetchWebformDetail.webformResponse.bankDetails)
        }else{
          this.setBankDetailsDropdownValues([]);
        }
        //This method clears out the bankDetails when a new Supplier ID is entered.
        this.clearBankData(this.nonPOPaymentData);
      } catch {
        this.isApiError = true
      }
    }
  }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #96c8da;
  overflow: auto;
  position: absolute;
  width: 100%;
  background: white;
  z-index: 99;
}

.autocomplete-results-height-100 {
  height: 150px;
}

.autocomplete-results-height-auto {
  height: auto;
}

.autocomplete-result {
  border-top: 1px solid #fafafa;
  list-style: none;
  text-align: left;
  padding: 0.78rem 0.85rem !important;
  font-family: artifaktElementRegular !important;
  font-size: 14px;
  cursor: pointer;
  white-space: normal;
  word-wrap: normal;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #fafafa;
  z-index: 13;
}

.icon-container {
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
}
.loader {
  position: relative;
  height: 20px;
  width: 20px;
  display: inline-block;
  animation: around 5.4s infinite;
}

@keyframes around {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

.loader::after, .loader::before {
  content: "";
  background: white;
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-color: #333 #333 transparent transparent;
  border-style: solid;
  border-radius: 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  animation: around 0.7s ease-in-out infinite;
}

.loader::after {
  animation: around 0.7s ease-in-out 0.1s infinite;
  background: transparent;
}

</style>